<template>
  <div class="content">
    <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="180px" class="demo-ruleForm">
      <el-form-item :label="$t('app.sendInterSms.form.agent')" prop="userId" v-show="adminShow" >
        <el-select v-model="ruleForm.userId" filterable clearable :placeholder="$t('app.sendInterSms.form.agentPlaceholder')" @change="changeAgent($event)">
          <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('app.sendInterSms.form.iccidList')" prop="msisdns" >
        <template slot="label">
          <el-tooltip :content="$t('app.sendInterSms.tooltip.iccidList')" placement="top">
            <span><i class="el-icon-question" style="color: black;"></i>{{ $t('app.sendInterSms.form.iccidList') }}</span>
          </el-tooltip>
        </template>
        <el-input v-model="ruleForm.msisdns" type="textarea" :placeholder="$t('app.sendInterSms.form.iccidPlaceholder')" rows="6" style="width:460px" ></el-input>
      </el-form-item>

      <el-form-item :label="$t('app.sendInterSms.form.smsTemplate')" prop="actionid">
        <el-select v-model="ruleForm.actionid" :placeholder="$t('app.sendInterSms.form.templatePlaceholder')" >
          <el-option v-for="item in smsTemplateOptions" :key="item.id" :label='item.type + "-" + item.actionId + "-" + item.scene'  :value="item.actionId"
                     @click.native="selectTemplate(item)">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-for="(item,index) in inputArr" :key="index" :label="$t('app.sendInterSms.form.param', { index: index + 1 })" prop="description">
        <el-input v-model="params[index]" :maxlength="20" @input="changeInputParams($event,index)" :placeholder="$t('app.sendInterSms.form.paramPlaceholder')" style="width:460px"></el-input>
      </el-form-item>

      <el-form-item :label="$t('app.sendInterSms.form.templateContent')" prop="tip">
        <template slot-scope="{}" slot="label">
          <el-tooltip class="item" effect="dark" placement="top">
            <span><i class="el-icon-question" style="color: black;"></i>{{ $t('app.sendInterSms.form.templateContent') }}</span>
            <div slot="content">{{ $t('app.sendInterSms.tooltip.templateContent') }}</div>
          </el-tooltip>
        </template>
        <template>
          <el-input v-model="ruleForm.content" type="textarea" :placeholder="$t('app.sendInterSms.form.contentPlaceholder')" autosize style="width:460px" disabled></el-input>
        </template>
      </el-form-item>

      <el-form-item>
         <el-button type="primary" size="medium" @click="send()" v-hasPermi="['sms:center:sendInter']">{{ $t('app.sendInterSms.button.send') }}</el-button>
      </el-form-item>

    </el-form>

    <div class="cardContent marge-class">
      <el-tabs v-model="activeName" @tab-click="handleClick" v-if="checkPermi(['sms:center:sentInter'])">
        <el-tab-pane :label="$t('app.sendInterSms.tab.sentRecord')" name="sent">
          <interSentList ref="sentListRef" ></interSentList>
        </el-tab-pane>
        <el-tab-pane :label="$t('app.sendInterSms.tab.replyRecord')" name="received" v-if="checkPermi(['sms:center:receivedInter'])">
          <interReceivedList ref="receivedListRef"></interReceivedList>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import interSentList from "@/components/sendSms/interSentList.vue";
import interReceivedList from "@/components/sendSms/interReceivedList.vue";

import {agentList, simSmsTemplateAll} from "@/api/api.js";
import {simInterSendSms,simInterSendBatchSms} from "@/api/international.js";
export default {
  name: "sendInterSms",
  data() {
    let checkMsisdns= (rule,value,callback) => {
      if(!value){
        return callback(new Error(this.$t('app.sendInterSms.validation.iccidRequired')))
      } else {
        let msisdnArr = value.trim().split(/[(\r\n)\r\n]+/);
        if(msisdnArr != null && msisdnArr.length > 2000){
          return callback(new Error(this.$t('app.sendInterSms.validation.iccidExceed')))
        } else {
          return callback()
        }
      }
    }
    return {
      activeName: "sent",
      agentList: [],
      ruleForm: {
        numberType:1,
        msisdn:"",
        msisdns:"",
        actionid:null,
        content:"",
        oldContent:"",
      },
      smsTemplateOptions:[],
      numberTypeOptions:[
        {value:1,label:"ICCID"}
      ],
      rules: {
        actionid: [
          { required: true, message: this.$t('app.sendInterSms.validation.selectTemplate'), trigger: "blur" }
        ],
        content: [
          { required: true, message: this.$t('app.sendInterSms.validation.enterContent'), trigger: "blur" },
        ],
        msisdns: [
          { required: true, validator:checkMsisdns, trigger: "blur" },
        ],
      },
      inputArr:[],
      params:[]
    };
  },
  components: {
    interSentList,interReceivedList
  },
  computed: {
    adminShow : {
      get() {
        return this.$store.getters.user.userType =='1'
      }
    },
  },
  methods: {
    //代理商下拉列表
    queryAgentList() {
      agentList().then(res => {
        this.agentList = res.data.data;
      });
    },
    changeInputParams(value,index) {
      let content = this.ruleForm.oldContent;
      this.params.forEach(function(item,index,arr){
        let number = index+1;
        content = content.replace("{"+number+"}","{"+item+"}");
      })
      this.ruleForm.content = content;
    },
    // 发送
    send(){
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
            let msisdnArr = this.ruleForm.msisdns.trim().split(/[(\r\n)\r\n]+/);
            if(msisdnArr != null && msisdnArr.length == 1){
              this.ruleForm.msisdn = this.ruleForm.msisdns.trim();
              this.sendSms();
            } else if(msisdnArr != null && msisdnArr.length > 1){
              this.sendBatchSms();
            }
        }
      })
    },
    // 发送短信
    sendSms() {
      let data = {
        ...this.ruleForm,
      };
      this.$alert(this.$t('app.sendInterSms.message.confirmContent'), this.$t('app.sendInterSms.message.confirmTitle'), {
        confirmButtonText: this.$t('app.common.confirm')
      }).then(() => {
        simInterSendSms(data).then(res => {
          if (res.data.code == 200) {
            this.$notify({
              title: this.$t('app.common.success'),
              message: this.$t('app.sendInterSms.message.sendSuccess'),
              type: "success"
            });
            this.ruleForm = {};
          } else {
            this.$message.error(res.data.message);
          }
          this.$refs.sentListRef.initData();
        });
      });
    },
    // 群发短信
    sendBatchSms() {
      let data = {
        ...this.ruleForm,
      };
      this.$alert(this.$t('app.sendInterSms.message.confirmContent'), this.$t('app.sendInterSms.message.confirmTitle'), {
        confirmButtonText: this.$t('app.common.confirm')
      }).then(() => {
        simInterSendBatchSms(data).then(res => {
          if (res.data.code == 200) {
            this.ruleForm = {}
            this.$notify.info({
              title: this.$t('app.common.tip'),
              message: this.$t('app.sendInterSms.message.batchTip'),
              duration: 1000,
              offset:30
            });
            setTimeout(()=>{
              this.$router.push(`/taskCenter/missionList`);
            },1000)
          } else {
            this.$message.error(res.data.message);
          }
          this.$refs.sentListRef.initData();
        });
      });
    },
    // 运营商
    transferType(status){
      let obj = {
        '1': this.$t('app.common.chinaTelecom'),
        '2': this.$t('app.common.chinaMobile'),
        '3': this.$t('app.common.chinaUnicom'),
        '4': this.$t('app.common.international'),
      };
      return obj[status];
    },
    // 
    getSmsTemplateOptions(value){
      let params ={userId:value};
      simSmsTemplateAll(params).then(res => {
        if(res.data.code == 200) {
          this.smsTemplateOptions = res.data.data;
          this.smsTemplateOptions.map((item,index)=>{
            item.type = this.transferType(item.type);
          })
        }
      });
    },
    // 选择代理商
    changeAgent(value){
      if(value !== ""){
        this.getSmsTemplateOptions(value);
      } else {
        this.smsTemplateOptions = [];
        this.$set(this.ruleForm, "actionid", null);
      }
    },
    // 选择模版
    selectTemplate(item){
      this.ruleForm.content = item.content;
      this.ruleForm.oldContent = item.content;
      let count = item.content.split(/\{[1-9]}/g).length-1;
      const inputArr = new Array(count).fill("")
      this.inputArr = inputArr;
    },
    handleClick(tab) {
      this.$router.push("/smsCenter/sendInterSms?msisdn=" + this.ruleForm.msisdns);
      if (tab.name == "sent") {
        this.$refs.sentListRef.initData();
      }else if(tab.name == "received"){
        this.$refs.receivedListRef.initData();
      }
    },
  },
  created() {
    if(this.adminShow){
      this.queryAgentList();
    } else {
      this.getSmsTemplateOptions(null);
    }

  },
  mounted() {

  }
};
</script>

